export default "__VITE_ASSET__QxMeS5dU__"